module.exports = __webpack_public_path__ + "static/media/crs_hotel_img.6a33b925.gif";